
const scrollToTop = document.querySelector('.scrollToTop');
const scrollToTopButton = document.querySelector('.scrollToTop button');
const lowerScrollBoundary = .55;
let lastKnownScrollPosition = 0;
let ticking = false;

function toggleBackToTop(scrollPos) {
    if (scrollPos > (window.innerHeight / 2)) {
        scrollToTop.classList.add('-visible');
    }
    else {
        scrollToTop.classList.remove('-visible');
    }
}

if (scrollToTop) {
    document.addEventListener("scroll", (event) => {
        lastKnownScrollPosition = window.scrollY;

        if (!ticking) {
            window.requestAnimationFrame(() => {
                toggleBackToTop(lastKnownScrollPosition);
                ticking = false;
            });

            ticking = true;
        }
    });

    scrollToTopButton.addEventListener('click', (event) => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
        });
    });
}
